var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTypeChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2212 5.93555H25.958",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2212 21.1133H25.958",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2965 9.22581C10.054 10.1631 9.23716 10.8488 8.26096 10.8488H3.08726C1.91893 10.8488 0.978516 9.8667 0.978516 8.64668V3.22423C0.978516 2.00421 1.91893 1.02197 3.08726 1.02197H8.26096",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56152 5.12969L8.23865 6.7424L12.9938 1.2417",
    stroke: "black",
    strokeWidth: 2.00001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2965 24.4035C10.054 25.3408 9.23716 26.0266 8.26096 26.0266H3.08726C1.91893 26.0266 0.978516 25.0444 0.978516 23.8244V18.402C0.978516 17.1819 1.91893 16.1997 3.08726 16.1997H8.26096",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56152 20.3074L8.23865 21.9201L12.9938 16.4194",
    stroke: "black",
    strokeWidth: 2.00001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.9578,
    height: 27.0483,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeChecklist);
export default __webpack_public_path__ + "static/media/icon_type_checklist.f443a1da2ee3e85fa4e8ebb7042b8f99.svg";
export { ForwardRef as ReactComponent };